import _ from 'lodash'
import { ActionTree } from 'vuex'
import { SEOState } from '@/modules/seo/store'
import { RootState } from '@/store/types'
import { MutationTypes } from '@/modules/seo/store/mutations'
import * as api from '@/modules/seo/api'

const actions: ActionTree<SEOState, RootState> = {

    /**
     * Invoca al componente encargado de completar el seo
     */
    completeSEO: ({state, commit}) => {
        const completor = state.seoCompletor

        // Si no existe ningún completador se termina el proceso
        if (!completor) {
            return
        }

        // Creación de una copia profunda del objeto Metadata, para evitar que el
        // completador modifique las referencias del objeto, los cambios serán
        // insertados al ejecutar la mutación
        const copy = _.cloneDeep(state.currentMetadata)
        const completed = completor.complete(copy, state.currentLocale)

        commit(MutationTypes.SetCurrentMetadata, completed)
    },

    initMetadataFields: ({state, commit}) => {
        const completor = state.seoCompletor

        // Si no existe ningún completador se termina el proceso
        if (!completor) {
            return
        }

        const metadataCopy = _.cloneDeep(state.currentMetadata)
        const touchedFieldsCopy = _.cloneDeep(state.touchedMetadataFields)

        // Inicializa los campos
        const touchedFields = completor.initFields(metadataCopy, touchedFieldsCopy)

        commit(MutationTypes.SetMetadataTouchedFields, touchedFields)
    },

    /**
     * Carga y muestra al usuario el reporte de análisis SEO de la información
     * meta mostrada actualmente
     */
    loadSEOAnalysisReport: async ({state, commit}) => {
        const id = state.currentMetadata.id
        if (!id) {
            throw new Error('No se puede generar un reporte de meta-información'
            + ' que no ha sido registrada en la base de datos')
        }

        commit(MutationTypes.SetAnalysisProcessing, true)

        const report = await api.getAnalysisReport(id, state.currentLocale)

        commit(MutationTypes.SetAnalysisProcessing, false)
        commit(MutationTypes.SetCurrentSEOReport, report)
    },
}

export default actions
